const providers = {
  xForta: {
    value: 'xForta',
    title: 'WithdrawToCard | xForta',
  },
  paylama: {
    value: 'paylama',
    title: 'WithdrawToCard | paylama',
  },
  mercuryo: {
    value: 'mercuryo',
    title: 'WithdrawToCard | mercuryo',
  },
}

export { providers }
